// extracted by mini-css-extract-plugin
module.exports = {"maincontainer":"appointmentRoom_maincontainer__Sidm9","roomBody":"appointmentRoom_roomBody__18fRv","CircularProgress":"appointmentRoom_CircularProgress__22qLS"};